import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { ANALYTICS_CONSENT_KEY, CONSENT_EVENT } from "./CookieConsent";

export const ymGoal = (goal) => {
  if (typeof window !== "undefined" && window.ym && window.__ymId && localStorage.getItem(ANALYTICS_CONSENT_KEY) === "accepted") {
    window.ym(window.__ymId, "reachGoal", goal);
  }
};

export default function Analytics() {
  const site = useSite();
  const id = site?.settings?.analytics?.yandex_metrica_id;
  const location = useLocation();
  const inited = useRef(false);
  const [allowed, setAllowed] = useState(() => localStorage.getItem(ANALYTICS_CONSENT_KEY) === "accepted");

  useEffect(() => {
    const sync = () => setAllowed(localStorage.getItem(ANALYTICS_CONSENT_KEY) === "accepted");
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);

  useEffect(() => {
    if (!allowed || !id || inited.current) return;
    const counter = Number(id);
    if (!counter) return;
    /* eslint-disable */
    (function (m, e, t, r, i, k, a) {
      m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
      m[i].l = 1 * new Date();
      for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) return; }
      k = e.createElement(t); a = e.getElementsByTagName(t)[0];
      k.async = 1; k.src = r; a.parentNode.insertBefore(k, a);
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    /* eslint-enable */
    window.ym(counter, "init", {
      defer: true,
      webvisor: true,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      ecommerce: "dataLayer",
    });
    window.__ymId = counter;
    inited.current = true;
  }, [allowed, id]);

  useEffect(() => {
    if (allowed && id && window.ym) window.ym(Number(id), "hit", window.location.href);
  }, [allowed, location.pathname, location.search, id]);

  return null;
}
